/**
 * @file Submission read-only / review UI components — lifecycleReadonlyRawMaterials.ts.
 */

import type { AnyObj } from "./readonlyFormDisplay";

/** Type definition — Normalized Lifecycle Raw Mat. */
export type NormalizedLifecycleRawMat = {
  id: number;
  catalogId: number | null;
  name: string;
  qty?: string;
  unitId?: number;
  idx: number;
};

/** Exported function — normalize Raw Materials From Submission. */
export function normalizeRawMaterialsFromSubmission(
  submission: AnyObj
): NormalizedLifecycleRawMat[] {
  const rows = (submission.backgroundRawMats ??
    submission.backgroundRawMaterials ??
    []) as AnyObj[];

  if (!Array.isArray(rows) || rows.length === 0) {
    return [{ id: 1, catalogId: null, name: "", idx: 0 }];
  }

  return rows.map((r, idx) => {
    const catalogIdRaw = r.rawMaterialId ?? r.raw_material_id ?? r.catalogId;
    const catalogId =
      catalogIdRaw != null && String(catalogIdRaw).trim() !== ""
        ? Number(catalogIdRaw)
        : null;
    const name = String(
      r.rawMaterialName ?? r.raw_material_name ?? r.name ?? ""
    ).trim();

    return {
      id:
        catalogId != null && Number.isFinite(catalogId) && catalogId > 0
          ? catalogId
          : idx + 1,
      catalogId:
        catalogId != null && Number.isFinite(catalogId) && catalogId > 0
          ? catalogId
          : null,
      name,
      qty: r.qty != null ? String(r.qty) : undefined,
      unitId:
        r.unitId != null ? Number(r.unitId) : undefined,
      idx,
    };
  });
}
